import React from "react";
import { Link, NavLink } from "react-router-dom";
const UserRoles = () => {
  const userroles = [
    {
      rolename: "Business Owner -",
      edit: "Edit Role",
    },
    {
      rolename: "Operations - N/A",
      edit: "Edit Role",
    },
    {
      rolename: "Developer/IT Specialist - N/A",
      edit: "Edit Role",
    },
    {
      rolename: "Customer support - N/A",
      edit: "Edit Role",
    },
    {
      rolename: "User - N/A",
      edit: "Edit Role",
    },
    {
      rolename: "Administrator - N/A",
      edit: "Edit Role",
    },
    {
      rolename: "Front desk - N/A",
      edit: "Edit Role",
    },
  ];
  return (
    <div className="">
      <h1 className="text-2xl font-bold pb-4">Configurations - User Roles</h1>
      <div className="bg-white h-[924px] py-5 px-[4rem] rounded-md">
        <section className="flex justify-between px-5 items-center border rounded-t-md w-full p-3">
          <div className="text-orange-400 text-[20px] font-semibold">
            Add user role
          </div>
          <div>
            <svg
              width="12"
              height="6"
              viewBox="0 0 12 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 0.75L6 5.25L10.5 0.75"
                stroke="#464255"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </section>
        <section className="flex justify-between">
          <div className="p-5 w-[60%] gap-5 flex flex-col">
            <p className="text-2xl font-medium">Role details</p>
            <p className="text-sm font-normal py-">
              Enter a name for this card scheme and a few required inputs. You
              can <br /> make changes to this much later.
            </p>
            <div className="flex flex-col gap-2 ">
              <label htmlFor="scheme" className="text-[16px]">
                Name of Role
              </label>
              <input
                className="h-[50px] bg-gray-200 w-[80%] rounded-md p-4"
                name="scheme"
                placeholder="Example:Chief of staff"
                type="text"
              />
            </div>
            <div className="flex flex-col gap-2 ">
              <label htmlFor="shortname" className="text-[16px]">
                Role description
              </label>
              <input
                className="h-[154px] bg-gray-200 w-[80%] rounded-md p-4"
                name="shortname"
                type="text"
              />
            </div>
            <div className="w-[40%] bg-orange-500 text-white flex justify-center p-2 rounded-md">
              Save User Role
            </div>
          </div>
          <div className="w-[30%] border pl-4 py-2 bg-white shadow-lg">
            <div className="border-b pb-4">
              <p className="text-[24px] font-medium">User Roles</p>
            </div>
            {userroles.map((r) => (
              <div className="flex gap-3 border-b py-5">
                <div className="pt-2 items-center gap-3">
                  {" "}
                  <svg
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.619995"
                      y="0.150391"
                      width="5"
                      height="5"
                      rx="2.5"
                      fill="#333333"
                    />
                  </svg>
                </div>
                <div>
                  <div>{r.rolename}</div>
                  <Link className="text-blue-600 border-b border-b-blue-600">
                    {r.edit}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default UserRoles;
